import {
    VIDEO_PLATFORM,
    VIDEO_PLATFORM_REGEX,
    VideoPlatform,
} from '../constants'

function videoPlatformRegex(platform: VideoPlatform) {
    if (typeof platform !== 'string') {
        throw new Error(`Invalid video platform: ${platform}`)
    }

    const key = Object.keys(VIDEO_PLATFORM).find(
        (_key) => VIDEO_PLATFORM[_key] === platform,
    )

    if (!key) {
        throw new Error(`Invalid video platform: ${platform}`)
    }

    return VIDEO_PLATFORM_REGEX[key]
}

export default videoPlatformRegex
